import { Theme } from '@mui/material/styles/createTheme';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  wrapper: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2),
    borderRadius: '4px',
  },
  filtersRow: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) 320px',
    gap: theme.spacing(1),
    alignItems: 'start',
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
  search: {
    width: '100%',
  },
  statusFilter: {
    width: '100%',
  },
  list: {
    marginTop: theme.spacing(1),
    '& > div + div': {
      marginTop: theme.spacing(1),
    },
  },
  listItem: {
    border: `1px solid ${theme.palette.grey[400]}`,
    borderRadius: '4px',
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(1.5),
    cursor: 'pointer',
    transition: 'border-color .15s ease',
    '&:hover': {
      borderColor: theme.palette.primary.main,
    },
  },
  listItemTop: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
    marginBottom: theme.spacing(0.5),
  },
  listItemMeta: {
    color: theme.palette.text.secondary,
  },
  statusRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  statusBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: '999px',
    border: `1px solid ${theme.palette.primary.light}`,
    color: theme.palette.primary.main,
    padding: `2px ${theme.spacing(1)}`,
    backgroundColor: theme.palette.action.hover,
  },
  footer: {
    marginBottom: theme.spacing(1),
  },
  emptyState: {
    marginTop: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  loadingState: {
    marginTop: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  modalBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    minWidth: 460,
    [theme.breakpoints.down('sm')]: {
      minWidth: 280,
    },
  },
  modalField: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  modalFieldLabel: {
    color: theme.palette.text.secondary,
  },
  modalFieldValue: {
    color: theme.palette.text.primary,
  },
  messageBox: {
    borderRadius: '4px',
    border: `1px solid ${theme.palette.grey[300]}`,
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.default,
    whiteSpace: 'pre-wrap',
  },
  modalActions: {
    marginTop: theme.spacing(1),
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));
